import React, { useMemo } from 'react';

const PHONE_REGEX = /(?<first>\d{3})(?<second>\d{3})(?<last>\d{4})/;

export type PhoneMaskProps = {
  phone: string;
  maskCharacter?: string;
};

export const PhoneMask: React.VFC<PhoneMaskProps> = ({ maskCharacter, phone: _phone }) => {
  const mask = maskCharacter ?? '\u22c5';
  const phone = useMemo(
    () => _phone.replace(/\D/g, '').match(PHONE_REGEX),
    [ _phone ]
  );

  if (!phone?.groups) {
    return <span>{_phone}</span>;
  }

  return (
    <span>
      ({mask} {mask} {mask}) {mask} {mask} {mask} - {phone.groups.last}
    </span>
  );
};
